import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSync, faPercent } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import NewCodigo from '../NewCodigo/NewCodigo';
import moneda from '../../moneda';

export default function CodigosData() {
    const [codigos, setCodigos] = useState([]);
    const [loading, setLoading] = useState(false);

    // Toasts con tu sistema global
    const [toasts, setToasts] = useState([]);
    const showToast = (message, type = 'info') => {
        const id = Date.now();
        setToasts(prev => [...prev, { id, message, type }]);
        setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3800);
    };

    useEffect(() => {
        cargarCodigos();
    }, []);

    const cargarCodigos = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${baseURL}/codigosGet.php`, { method: 'GET' });
            const data = await res.json();
            setCodigos(data.codigos || []);
        } catch (e) {
            console.error('Error al cargar códigos:', e);
            showToast('Error al cargar códigos', 'error');
        } finally {
            setLoading(false);
        }
    };

    const eliminarCodigo = (idCodigo) => {
        Swal.fire({
            title: '¿Eliminar código?',
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await fetch(`${baseURL}/codigosDelete.php?idCodigo=${idCodigo}`, { method: 'DELETE' });
                    const data = await res.json();
                    if (data?.mensaje) {
                        showToast('Código eliminado', 'success');
                        cargarCodigos();
                    } else {
                        showToast(data?.error || 'No se pudo eliminar', 'error');
                    }
                } catch (e) {
                    console.error('Error al eliminar código:', e);
                    showToast('Error de conexión al eliminar', 'error');
                }
            }
        });
    };

    const refresh = () => {
        cargarCodigos();
        showToast('Lista actualizada', 'info');
    };

    const formatMoney = (v) => {
        const num = Number(v || 0);
        // Mantiene tu prefijo `moneda` y separadores en es-CO
        return `${moneda} ${num.toLocaleString('es-CO')}`;
    };

    return (
        <div>
            {/* Toasts globales */}
            {toasts.length > 0 && (
                <div className="product-toast-container">
                    {toasts.map(t => (
                        <div key={t.id} className={`product-toast ${t.type}`}>
                            <div className="toast-icon">
                                {t.type === 'success' && '✅'}
                                {t.type === 'error' && '❌'}
                                {t.type === 'warning' && '⚠️'}
                                {t.type === 'info' && 'ℹ️'}
                            </div>
                            <div className="toast-content">
                                <div className="toast-title">{t.message}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {/* Header global */}
            {/* Header más compacto con stats inline */}
            <div className="global-component-header" style={{ padding: '12px 16px' }}>
                <div className="flex-between">
                    <div className="flex-center" style={{ gap: '16px' }}>
                        <div className="global-component-title">
                            <FontAwesomeIcon icon={faPercent} />
                            Códigos de descuento
                        </div>

                        <div className="flex-center" style={{ gap: '12px' }}>
                            <div className="global-stat-card compact">
                                <span className="global-stat-number">{codigos.length}</span>
                                <span className="global-stat-label">Total</span>
                            </div>

                            <div className="global-stat-card compact">
                                <span className="global-stat-number">
                                    {codigos.length
                                        ? Math.max(0, ...codigos.map(c => Number(c?.descuento || 0))).toLocaleString('es-CO')
                                        : 0}
                                </span>
                                <span className="global-stat-label">Mayor desc.</span>
                            </div>

                            <div className="global-stat-card compact">
                                <span className="global-stat-number">
                                    {codigos.length
                                        ? Math.round(
                                            codigos.reduce((acc, c) => acc + Number(c?.descuento || 0), 0) / codigos.length
                                        ).toLocaleString('es-CO')
                                        : 0}
                                </span>
                                <span className="global-stat-label">Promedio</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex-center" style={{ gap: '8px' }}>
                        <button
                            className="btn-product-secondary compact flex-center"
                            style={{ marginLeft: "10px" }}
                            onClick={refresh}
                            title="Actualizar"
                        >
                            <FontAwesomeIcon icon={faSync} />
                        </button>
                    </div>
                </div>
            </div>


            {/* Crear nuevo código */}
            <div className="mb-24">
                <NewCodigo onCreated={cargarCodigos} />
            </div>

            {/* Tabla global */}
            <div className="global-table-container">
                {loading ? (
                    <div className="global-loading-state">
                        <FontAwesomeIcon icon={faSync} size="2x" />
                        <div>Cargando códigos...</div>
                    </div>
                ) : codigos.length > 0 ? (
                    <table className="global-table">
                        <thead>
                            <tr>
                                <th>Id Código</th>
                                <th>Código</th>
                                <th>Descuento</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {codigos.map((item, index) => (
                                <tr key={item.idCodigo} style={{ animationDelay: `${index * 0.05}s` }}>
                                    <td>{item.idCodigo}</td>
                                    <td><strong>{item.codigo}</strong></td>
                                    <td style={{ color: '#059669', fontWeight: 700 }}>{formatMoney(item.descuento)}</td>
                                    <td>
                                        <div className="global-table-actions">
                                            <button
                                                className="global-btn-delete"
                                                title="Eliminar"
                                                onClick={() => eliminarCodigo(item.idCodigo)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="global-empty-state">
                        <FontAwesomeIcon icon={faPercent} size="3x" />
                        <div className="global-empty-title">No hay códigos</div>
                        <div className="global-empty-description">
                            Crea tu primer código con el formulario superior.
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
